import React from 'react'
import './ButtonMain.css'
import {ReactComponent as ArrowWhite} from '../assets/arrowRightWhite.svg'

function ButtonMain(props) {
    return (
        <div className="btnMainWrapper">
        <button className="btnMain">
            <p className="btnContent">{props.mainbtn}<ArrowWhite/></p>
        </button>
        </div>
    )
}

export default ButtonMain
